import { ref } from 'vue';

class ThemeService {
  themes = ['light', 'dark']
  themeClassNamePrefix = 'dx-swatch-';
  currentTheme = ref('');
  isDark = ref(false);

  constructor() {
    const saved = localStorage.getItem('node-agent-theme') || 'dark';
    this.currentTheme.value = saved;
    this.isDark.value = saved === 'dark';
    document.body.classList.add(this.themeClassNamePrefix + saved);
  }

  switchAppTheme() {
    const prevTheme = this.currentTheme.value;
    const isCurrentThemeDark = prevTheme === 'dark';

    this.currentTheme.value = this.themes[prevTheme === this.themes[0] ? 1 : 0];

    document.body.classList.replace(
      this.themeClassNamePrefix + prevTheme,
      this.themeClassNamePrefix + this.currentTheme.value
    );

    const additionalClassNamePrefix = this.themeClassNamePrefix + 'additional';
    const additionalClassNamePostfix = isCurrentThemeDark ? '-' + prevTheme : '';
    const additionalClassName = `${additionalClassNamePrefix}${additionalClassNamePostfix}`

    document.body
      .querySelector(`.${additionalClassName}`)?.classList
      .replace(additionalClassName, additionalClassNamePrefix + (isCurrentThemeDark ? '' : '-dark'));

    this.isDark.value = this.currentTheme.value === 'dark';
    localStorage.setItem('node-agent-theme', this.currentTheme.value);
  }
}

export const themeService = new ThemeService();
